import React from "react";
import {
  //   Footer,
  Header,
  PaymentRequired,
} from "webapp/components";
import { useTranslation } from "react-i18next";

export default function PaymentRequiredContainer(props) {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Header
        currState={props.currState}
        information={t("description.PaymentRequiredHeader1")}
      />
      <PaymentRequired
        currState={props.currState}
        quoteAmount={props.quoteAmount}
        quoteCurrency={props.quoteCurrency}
        companyParams={props.companyParams}
        encCallGUID={props.encCallGUID}
        onUserCancel={props.onUserCancel}
        partnerCode={props.partnerCode}
      />
      {/* <Footer /> */}
    </React.Fragment>
  );
}
